import { Heading2XL, Heading3XL } from "../../../typography";

import { Fragment } from "react";
import { GridCard } from "../../components/ui/GridCard";
import { Testimonial } from "../../components/types";

export const TestimonialSection = ({
  testimonials,
}: {
  testimonials: Testimonial[];
}) => {
  return (
    <div className="tw-z-20 tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-[1em]">
      <div className="tw-flex tw-flex-col">
        <Heading3XL className="tw-my-0 tw-hidden tw-text-blue-dark-3 min440:tw-flex">
          What our providers say
        </Heading3XL>
        <Heading2XL className="tw-my-0 tw-text-blue-dark-3 min440:tw-hidden">
          What our providers say
        </Heading2XL>
      </div>

      <div className="tw-hidden tw-grid-cols-6 tw-grid-rows-7 tw-gap-[1em] tw-p-[15px] min1040:tw-grid">
        <GridCard
          testimonial={testimonials[0]}
          className="tw-col-span-2 tw-row-span-3"
        />

        <div className="tw-col-span-1 tw-row-span-2 tw-grid">
          <img
            src="landing_page_assets/provider_testimonials/testimonial1.png"
            alt="testimonial1"
            className="tw-h-full tw-w-full tw-rounded-[1.5em] tw-object-cover"
          />
        </div>
        <div className="tw-col-span-1 tw-row-span-2 tw-grid">
          <img
            src="landing_page_assets/provider_testimonials/testimonial2.png"
            alt="testimonial2"
            className="tw-h-full tw-w-full tw-rounded-[1.5em] tw-object-cover"
          />
        </div>

        <GridCard
          testimonial={testimonials[1]}
          className="tw-col-span-2 tw-row-span-3 tw-grid tw-gap-[10px]"
        />

        <GridCard
          testimonial={testimonials[2]}
          className="tw-col-span-2 tw-row-span-3 tw-grid tw-gap-[10px]"
        />

        {/* Bottom image */}
        <div className="tw-col-span-2 tw-row-span-4 tw-overflow-hidden">
          <img
            src="landing_page_assets/provider_testimonials/testimonial4.png"
            alt="testimonial4"
            className="tw-h-full tw-w-full tw-rounded-[1.5em]"
          />
        </div>
        <div className="tw-col-span-2 tw-row-span-2">
          <img
            src="landing_page_assets/provider_testimonials/testimonial3.png"
            alt="testimonial3"
            className="tw-h-full tw-w-full tw-rounded-[1.5em] tw-object-cover"
          />
        </div>

        <GridCard
          testimonial={testimonials[3]}
          className="tw-col-span-4 tw-row-span-2"
        />
      </div>

      {/* MOBILE */}
      <div className="tw-flex tw-h-[305px] tw-w-full tw-gap-[1em] tw-overflow-x-scroll min1040:tw-hidden">
        {testimonials.map((testimonial) => (
          <Fragment key={testimonial.text}>
            <GridCard
              testimonial={testimonial}
              className="tw-shrink-0 tw-basis-full tw-overflow-y-hidden min840:tw-basis-[32%]"
            />
          </Fragment>
        ))}
      </div>
    </div>
  );
};
